import styles from './TableCaption.module.scss';

type Props = {
  /**
   * The content to render within the component.
   */
  children: React.ReactNode;
  /**
   * Whether to show the node or hide it accessibly.
   * Generally this won't want to be shown but needs to
   * exist in the DOM for a11y purposes.
   */
  show?: boolean;
};

/**
 * The `caption` tag; use describe table data. Necessary for
 * accessibility, so always include it in your `Table`.
 */
export const TableCaption = ({ children, show = false }: Props) => {
  return (
    <caption
      className={styles.tableCaption}
      data-show={show ? true : undefined}
      data-zds
    >
      {children}
    </caption>
  );
};
